import { createAction } from '@reduxjs/toolkit';
import { stateName } from './constants';
export const fetchCountriesRequest = createAction("".concat(stateName, "/fetchCountriesRequest"));
export const fetchCountriesFailure = createAction("".concat(stateName, "/fetchCountriesFailure"));
export const searchCitiesRequest = createAction("".concat(stateName, "/searchCitiesRequest"));
export const searchCitiesFailure = createAction("".concat(stateName, "/searchCitiesFailure"));